<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-container grid-list-md fluid>
      <v-layout row wrap>
        <v-flex xs12 sm6 md12>
          <span>Buscar por:</span>
          <v-divider/>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-combobox
            v-model="residente"
            :items="residentes"
            :loading="residenteIsLoading"
            :search-input.sync="residenteSearch"
            :hide-no-data="!residenteSearch"
            hide-selected
            item-text="telefono"
            item-value="id"
            label="Teléfono"
            placeholder="Comience a escribir para buscar"
            return-object
            @change="residenteChange($event)"
          >
            <template v-slot:selection="data">
              {{ data.item.telefono }}
            </template>
            <template v-slot:item="data">
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.telefono"></v-list-tile-title>
                <v-list-tile-sub-title>
                  {{ data.item.nombres }} {{ data.item.apellidos }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-combobox>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="pb-2">
        <v-flex xs12 sm12 md12>
          <strong>Datos Residente</strong>
          <v-divider/>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <v-text-field
            v-model="nombres_residente"
            label="Nombre"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm4 md4>
          <v-text-field
            v-model="apellidos_residente"
            label="Apellidos"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm4 md4>
          <v-text-field
            v-model="telefono"
            label="Teléfono"
            readonly
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap class="pb-2">
        <v-flex xs12 sm12 md12>
          <strong>Viviendas</strong>
          <v-divider/>
        </v-flex>
        <template v-for="(vivienda, index) in viviendas">
          <v-flex xs12 sm4 md4>
            <v-text-field
              v-model="vivienda.desarrollo"
              label="Condominio"
              readonly
            />
          </v-flex>
          <v-flex xs12 sm4 md4>
            <v-text-field
              v-model="vivienda.subcondominio"
              label="Subcondominio"
              readonly
            />
          </v-flex>
          <v-flex xs12 sm4 md4>
            <v-text-field
              v-model="vivienda.n_vivienda"
              label="Vivienda"
              readonly
            />
          </v-flex>
        </template>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import ApiService from '../common/api.service';

function initialState() {
  return {
    valid: true,
    viviendas: [],
    residente: null,
    residenteIsLoading: false,
    residenteSearch: null,
    residentesApiResult: [],
    nombres_residente: '',
    apellidos_residente: '',
    telefono: '',
  };
}
export default {
  data() {
    return initialState();
  },
  computed: {
    residentes() {
      return this.residentesApiResult;
    },
  },
  watch: {
    residente(val) {
      let newVal = val;
      if (val !== null) {
        if (typeof val === 'string') {
          const newItem = {
            telefono: val,
            nombres_residente: '',
            apellidos_residente: '',
            desarrollo: '',
            subcondominio: '',
            n_vivienda: '',
            residente_id: null,
          };
          this.residentesApiResult.unshift(newItem);
          this.residente = newItem;
          newVal = newItem;
        } else {
          this.nombres_residente = val.nombres;
          this.apellidos_residente = val.apellidos;
          if (Array.isArray(val.viviendas)) {
            [this.selected_vivienda] = val.viviendas;
            this.viviendas = val.viviendas;
          } else {
            this.desarrollo = val.desarrollo;
            this.subcondominio = val.subcondominio;
            this.resident_status = val.tipo;
            const newItem = {
              desarrollo: val.desarrollo,
              subcondominio: val.subcondominio,
              tipo: val.tipo,
              n_vivienda: val.n_vivienda,
              vivienda_id: val.vivienda_id,
              residente_id: val.id,
            };
            this.viviendas = [];
            this.viviendas.push(newItem);
            this.selected_vivienda = newItem;
          }
          this.telefono = val.telefono;
          this.notas = val.notas;
          this.residente_id = val.id;
        }
      }
      return newVal;
    },
    residenteSearch() {
      // Items have already been loaded
      if (this.residentes.length > 0) return;
      // Items have already been requested
      if (this.residenteIsLoading) return;
      if (this.residenteSearch.length >= 3) {
        this.residenteIsLoading = true;
        ApiService.setHeader();
        ApiService.query('accesos/telephones')
          .then(({ data }) => {
            this.residentesApiResult = data.residentes;
          })
          .catch(({ response }) => {
            console.log(response);
          })
          .finally(() => {
            this.residenteIsLoading = false;
          });
      }
    },
  },
  methods: {
    residenteChange(event) {
      this.nombres_residente = '';
      this.apellidos_residente = '';
      this.telefono = '';
      this.viviendas = [];
    },
  },
  created() {
  },
};
</script>
